import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDifferenceIgnored: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="difference-ignored"><path fillRule="evenodd" clipRule="evenodd" d="M19.25 3C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H19.25ZM15.7803 8.21973C15.4874 7.92683 15.0126 7.92683 14.7197 8.21973L8.21973 14.7197C7.92683 15.0126 7.92683 15.4874 8.21973 15.7803C8.51262 16.0732 8.98738 16.0732 9.28027 15.7803L15.7803 9.28027C16.0732 8.98738 16.0732 8.51262 15.7803 8.21973Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDifferenceIgnored;
